export default "__VITE_ASSET__56337423__"